import { GET_SECTORS} from "./actionType";

const initialState = {
  sectors: []
};

export default function(state = initialState, action) {

  switch (action.type) {
    case GET_SECTORS:{
      console.log("[action.type]", action.type)
      console.log("[action.payload]", action.payload)
      return { ...state, sectors: action.payload };
    }
    default:
      return state;
  }
}
